<div ngbDropdown placement="bottom" autoClose="outside" class="kt-header__topbar-item"
     (openChange)="openChange($event)">
    <div ngbDropdownToggle class="kt-header__topbar-wrapper">
        <span
            class="kt-header__topbar-icon"
            [ngClass]="{
                'kt-pulse kt-pulse--brand': pulse,
                'kt-pulse--light': pulseLight,
                'kt-header__topbar-icon--success': iconType === 'success'
            }"
        >
            <i *ngIf="!useSVG" [ngClass]="icon"></i>
            <span
                *ngIf="useSVG"
                class="kt-svg-icon"
                [ngClass]="{ 'kt-svg-icon--success': iconType === 'success' }"
                [inlineSVG]="icon"
            ></span>
            <span class="kt-pulse__ring" [hidden]="!pulse"></span>
        </span>
        <span class="kt-badge kt-badge--dot kt-badge--notify kt-badge--danger" [hidden]="!dot"></span>
    </div>

    <div
        ngbDropdownMenu
        class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg"
    >
        <form>
            <!--begin: Head -->
            <div
                class="kt-head kt-head--skin-{{ skin }} kt-head--fit-x kt-head--fit-b"
                [ngStyle]="{ 'background-image': backGroundStyle() }"
            >
                <h3 class="kt-head__title pb-3">
                    Bildirimler&nbsp;
                    <span class="btn btn-{{ type }} btn-sm btn-bold btn-font-md">{{
                        notifications ? notifications.length : 0
                        }}</span>
                </h3>
                <div
                    [perfectScrollbar]="{ wheelPropagation: false }"
                    [ngStyle]="{ 'max-height': '40vh', position: 'relative' }"
                    class="kt-notification kt-margin-t-10 kt-margin-b-10 bg-white"
                >
                    <a
                        href="javascript:;"
                        class="kt-notification__item"
                        *ngFor="let notification of notifications"
                        [ngClass]="{ 'kt-notification__item--read': notification.isRead }"
                        (click)="onNotificationSelected($event, notification)"
                    >
                        <div class="kt-notification__item-icon">
                            <i class="flaticon2-line-chart kt-font-success"></i>
                        </div>
                        <div class="kt-notification__item-details">
                            <div class="kt-notification__item-title">
                                {{ notification.title }}
                            </div>
                            <div class="kt-notification__item-time">
                                {{ notification.creationDate | date: 'dd.MM.yyyy' }}
                            </div>
                        </div>
                    </a>
                    <div *ngIf="notifications && notifications.length == 0" class="text-center p-3">
                        <span class="text-info">Bildirim bulunamadı.</span>
                    </div>
                    <div class="ps__rail-x" style="left: 0px; bottom: 0px;">
                        <div class="ps__thumb-x" tabindex="0" style="left: 0px; width: 0px;"></div>
                    </div>
                    <div class="ps__rail-y" style="top: 0px; right: 0px;">
                        <div class="ps__thumb-y" tabindex="0" style="top: 0px; height: 0px;"></div>
                    </div>
                </div>
            </div>
            <!--end: Head -->
        </form>
    </div>
</div>
